export const TOOL_TYPE_LIST = [
  {
    name: 'Part',
    slug: 'Part',
    icon: `
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                ></path>
                <path
                  d="M11.9996 9.13287C14.5374 9.13287 16.8107 9.72331 18.3438 10.6556C18.6506 10.842 19.0123 10.5289 18.9015 10.1687C17.9462 7.0508 15.2171 4.7998 11.9996 4.7998C8.78203 4.7998 6.05294 7.0508 5.09757 10.1687C4.98681 10.5289 5.34856 10.8428 5.65533 10.6556C7.1876 9.72331 9.46171 9.13287 11.9996 9.13287Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                ></path>
                <path
                  d="M5.2686 13.9365C5.79848 13.3118 8.83752 11.8576 10.2009 12.8903C11.5642 13.923 10.7347 17.0521 10.2049 17.6776C9.67497 18.3023 8.14031 17.9716 6.77696 16.9381C5.41362 15.9055 4.73872 14.5612 5.2686 13.9365Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                ></path>
                <path
                  d="M18.771 13.9365C18.2411 13.3118 15.2021 11.8576 13.8387 12.8903C12.4754 13.923 13.3049 17.0521 13.8347 17.6776C14.3646 18.3023 15.8993 17.9716 17.2626 16.9381C18.626 15.9055 19.3009 14.5612 18.771 13.9365Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                ></path>
              </svg>
    `,
  },
  {
    name: 'Wrap',
    slug: 'Wrap',
    icon: `
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path
                  d="M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
    `,
  },
  // {
  //   name: 'Sticker',
  //   slug: 'Sticker',
  //   icon: `
  //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  //       <path
  //         d="M15.5 2H9C7.89543 2 7 2.89543 7 4V20C7 21.1046 7.89543 22 9 22H15C16.1046 22 17 21.1046 17 20V6.5L15.5 2Z"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M15 2V6.5H19.5"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M9 9H15"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M9 13H15"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M9 17H12"
  //         stroke="currentColor"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   `,
  // },
  {
    name: 'Livery',
    slug: 'Livery',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 2L2 7L12 12L22 7L12 2Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 17L12 22L22 17"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 12L12 17L22 12"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `,
  },
  {
    name: 'AI',
    slug: 'AI agent',
    icon: `
      <svg
                xmlns="http://www.w3.org/2000/svg"

                viewBox="0 0 32 37"
                fill="none"
              >
                <path
                  d="M29.2537 17.136C29.3215 16.8305 29.2288 16.5067 28.8659 16.1581C28.2784 15.5941 27.4845 15.3826 27.4427 14.4386C27.4245 14.0104 27.5563 13.59 27.7182 13.1931C28.1243 12.1995 28.6335 11.2216 28.8241 10.1549C28.9403 9.50596 29.0604 8.17553 28.1256 8.18989C27.5041 8.20034 26.2546 8.96152 25.7206 8.62336C25.4569 8.45624 25.1749 8.22645 25.0391 7.89874C24.8746 7.50183 25.0104 7.07619 25.0809 6.65317C25.1357 6.32285 25.1788 5.98991 25.2062 5.65698C25.2467 5.16084 25.2571 4.65948 25.201 4.17117C25.1566 3.78993 25.0809 3.3421 24.872 3.04311C24.8067 2.94911 24.7062 2.89688 24.6004 2.9008C24.4933 2.90472 24.3915 2.96477 24.3197 3.064C23.8353 3.7377 23.2752 4.33438 22.6655 4.84096C22.2907 5.1517 21.9121 5.49508 21.5035 5.73662C21.2345 5.89591 20.9133 5.97947 20.6522 5.83846C20.3258 5.6622 20.1247 5.18695 19.9315 4.84879C19.6782 4.40488 19.4471 3.93877 19.2643 3.44655C19.0946 2.99219 18.9366 2.49867 18.8752 1.996C18.8517 1.79885 18.7146 1.65654 18.5449 1.65392C18.3752 1.65131 18.2198 1.78971 18.1715 1.98686C18.0892 2.3211 17.6662 3.11623 17.1009 3.86827C16.8672 4.17901 16.6165 4.48844 16.3319 4.7339C16.1517 4.88927 15.8801 5.06553 15.8605 4.67776C15.7744 2.95041 15.1046 1.36277 13.7154 0.6969C13.6188 0.649898 13.5065 0.659037 13.4099 0.719096C13.3133 0.78046 13.2414 0.887522 13.2127 1.01156C13.0665 1.6709 12.7544 3.45177 12.035 3.58495C11.5742 3.67112 11.2256 2.92561 10.9971 2.56917C10.5427 1.86282 10.1811 1.08728 10.1784 1.07945C10.1027 0.916245 9.93951 0.839213 9.78153 0.892744C9.62355 0.946275 9.50735 1.11601 9.49821 1.30793C9.49821 1.31968 9.44207 2.49866 9.27234 3.6907C9.17833 4.34874 9.10913 5.012 8.84018 5.62303C8.80231 5.7079 8.76053 5.79276 8.69917 5.85413C8.24611 6.29804 7.94843 4.97674 7.89229 4.67645C7.80612 4.22209 7.78001 3.72726 7.82179 3.25462C7.84006 3.04181 7.72517 2.8551 7.55152 2.81593C7.37787 2.77807 7.1977 2.89688 7.1285 3.09795C7.12066 3.11884 6.39865 5.21176 5.59308 6.09175C5.10086 6.62967 4.26787 6.17923 3.83309 5.8489C3.72342 5.76534 3.61114 5.66873 3.47666 5.6635C3.28212 5.65698 3.09411 5.88285 3.10325 6.11264C3.10978 6.27062 3.19203 6.40118 3.26645 6.52783C3.80829 7.45352 4.12947 8.8884 3.81743 10.0517C3.53149 11.1197 2.42171 11.5871 1.59003 11.6485C1.33021 11.6681 0.995967 11.7086 0.912407 12.0062C0.837986 12.2713 1.03905 12.5011 1.2127 12.6695C1.7219 13.1643 2.16842 13.7675 2.43216 14.4908C2.89827 15.7677 2.63583 18.2054 1.22184 18.7211C1.03905 18.7824 0.918935 18.9966 0.942437 19.2133C0.965938 19.43 1.12653 19.5802 1.31323 19.5593C1.34457 19.5554 4.43891 19.2081 5.94691 19.7395C6.1545 19.8126 6.27984 19.9431 6.3412 20.152C6.56969 20.9263 5.90121 22.493 5.64922 22.9813C5.55522 23.1628 5.58002 23.3887 5.70798 23.5206C5.83593 23.6511 6.03047 23.6485 6.17017 23.514C6.18453 23.4997 7.67033 22.0896 9.32326 22.1392C9.7985 22.1536 9.90165 22.3729 9.9356 22.446C10.1602 22.92 10.1171 23.8979 9.98129 24.2086C9.8899 24.4162 9.94865 24.6604 10.1119 24.7661C10.2764 24.8719 10.4905 24.8001 10.5989 24.6042C10.6093 24.5846 11.4018 22.6536 12.5664 22.7894C13.624 22.9121 13.5222 25.5978 13.5208 25.6239C13.5117 25.7989 13.594 25.9569 13.7284 26.0208C13.7533 26.0326 13.7794 26.0417 13.8055 26.0456C13.9204 26.0665 14.0418 26.0195 14.1293 25.9151C14.6319 25.3197 15.1633 24.7557 15.7117 24.2204C16.3005 23.6459 17.0278 22.8756 17.7759 22.651C18.712 22.3703 19.4197 23.954 19.7017 24.7648C19.7617 24.9372 19.9132 25.0338 20.0738 25.0038C20.2344 24.9724 20.3649 24.8197 20.3937 24.6303C20.3963 24.6095 20.7318 22.4839 21.9487 21.7645C22.9618 21.1665 24.8067 22.1431 25.4321 22.5701C25.5339 22.6393 25.6606 22.6419 25.7715 22.5766C25.8825 22.5113 25.9622 22.3873 25.9831 22.245C26.1737 21.0007 26.8252 19.9275 27.6438 18.994C28.1556 18.4116 29.1035 17.8202 29.255 17.1387V17.136H29.2537Z"
                  fill="black"
                />
                <path
                  d="M18.6693 16.5979C20.4568 16.5979 21.9059 15.0173 21.9059 13.0675C21.9059 11.1177 20.4568 9.53711 18.6693 9.53711C16.8817 9.53711 15.4326 11.1177 15.4326 13.0675C15.4326 15.0173 16.8817 16.5979 18.6693 16.5979Z"
                  fill="white"
                />
                <path
                  d="M11.6058 16.7278C13.3933 16.7278 14.8424 15.1472 14.8424 13.1974C14.8424 11.2476 13.3933 9.66699 11.6058 9.66699C9.81824 9.66699 8.36914 11.2476 8.36914 13.1974C8.36914 15.1472 9.81824 16.7278 11.6058 16.7278Z"
                  fill="white"
                />
                <path
                  d="M5.85731 16.1281C6.96128 16.1281 7.85623 15.1513 7.85623 13.9464C7.85623 12.7414 6.96128 11.7646 5.85731 11.7646C4.75334 11.7646 3.8584 12.7414 3.8584 13.9464C3.8584 15.1513 4.75334 16.1281 5.85731 16.1281Z"
                  fill="white"
                />
                <path
                  d="M24.4276 14.546C25.5316 14.546 26.4265 13.5692 26.4265 12.3643C26.4265 11.1594 25.5316 10.1826 24.4276 10.1826C23.3237 10.1826 22.4287 11.1594 22.4287 12.3643C22.4287 13.5692 23.3237 14.546 24.4276 14.546Z"
                  fill="white"
                />
                <path
                  d="M11.5007 15.6339C11.7732 15.2668 11.6158 14.6884 11.1492 14.342C10.6825 13.9955 10.0833 14.0122 9.8108 14.3793C9.53829 14.7464 9.69568 15.3248 10.1623 15.6712C10.629 16.0177 11.2282 16.0009 11.5007 15.6339Z"
                  fill="black"
                />
                <path
                  d="M20.8832 11.4959C20.8049 11.9464 20.2761 12.2297 19.7042 12.1292C19.1311 12.0286 18.7302 11.5834 18.8099 11.133C18.8882 10.6825 19.417 10.3992 19.9889 10.4998C20.562 10.6003 20.9629 11.0455 20.8832 11.4959Z"
                  fill="black"
                />
                <path
                  d="M25.5714 13.136C25.7242 13.3802 25.5962 13.7353 25.2855 13.9286C24.9748 14.1231 24.6 14.0826 24.4473 13.8385C24.2945 13.5943 24.4225 13.2392 24.7332 13.0459C25.044 12.8514 25.4187 12.8919 25.5714 13.136Z"
                  fill="black"
                />
                <path
                  d="M5.74819 12.7229C5.90095 12.9671 5.773 13.3222 5.46226 13.5155C5.15152 13.71 4.7768 13.6695 4.62405 13.4254C4.47129 13.1812 4.59924 12.8261 4.90998 12.6329C5.22072 12.4383 5.59543 12.4788 5.74819 12.7229Z"
                  fill="black"
                />
                <path
                  d="M18.5255 20.9113C18.5255 20.9113 19.6784 23.3123 19.0256 24.9835C18.3728 26.6547 17.2773 29.6707 17.2773 29.9201C17.2773 30.1695 17.5084 30.458 18.0464 30.3431C18.5843 30.2283 21.0245 25.8479 21.3692 24.7146C21.7152 23.5813 21.3117 20.5261 21.1577 20.1815C21.0036 19.8368 18.5255 20.9113 18.5255 20.9113Z"
                  fill="black"
                />
                <path
                  d="M17.9312 28.1339C17.9312 28.1339 17.2209 27.8271 16.3553 28.6914C15.4896 29.5558 16.0289 31.0925 17.3162 31.4959C18.6036 31.8994 19.8517 30.8614 19.1219 28.7868C19.1219 28.7868 18.2771 28.0948 17.9312 28.1339Z"
                  fill="black"
                />
                <path
                  d="M16.6062 28.5384C16.6062 28.5384 15.4338 28.4809 14.6465 29.3648C13.8592 30.2487 14.589 33.9176 16.6062 35.6083C18.6234 37.2991 21.1394 36.1084 21.6198 35.4934C22.1003 34.8785 22.4071 33.6499 21.6003 32.7268C20.7934 31.805 18.0659 32.343 17.6233 34.244C17.6233 34.244 17.3922 33.0715 18.9302 32.0923C18.9302 32.0923 18.5072 31.8233 19.0073 31.0165C19.5073 30.2096 17.5084 28.4039 16.6062 28.5384Z"
                  fill="black"
                />
                <path
                  d="M9.13281 21.1634L10.1734 27.4487H11.5939L11.6357 20.9414L9.13281 21.1634Z"
                  fill="black"
                />
                <path
                  d="M10.4528 27.2014C10.4528 27.2014 9.27254 27.2014 8.92654 27.879C8.58055 28.5566 9.13936 28.7838 9.37307 28.7433C9.60678 28.7042 9.7739 28.1558 11.0155 28.2864C12.2572 28.4169 12.3329 28.5044 12.6267 28.114C12.9205 27.7249 12.4073 27.1714 11.3145 27.0956C10.2217 27.0199 10.4528 27.2014 10.4528 27.2014Z"
                  fill="black"
                />
                <path
                  d="M9.96435 30.2841C9.96435 30.2841 9.37943 29.1025 7.11678 29.2043C4.85413 29.3061 4.35408 32.031 5.50956 32.8366C6.66503 33.6408 11.7152 32.8692 12.351 32.6015C12.9856 32.3339 13.3551 31.7921 13.0378 30.8651C12.7218 29.9381 12.2218 28.4026 12.1918 28.1076C12.1617 27.8125 9.78287 27.9339 9.78287 27.9339L9.30501 28.5162C9.30501 28.5162 9.73326 29.1155 9.96566 30.2827H9.96435V30.2841Z"
                  fill="black"
                />
                <path
                  d="M7.84045 18.596C7.84045 18.596 5.80889 19.6288 5.5791 21.2334C5.34931 22.8393 5.21875 24.1985 5.21875 24.1985L6.2515 24.7233C6.2515 24.7233 7.16936 21.5938 7.29992 21.1511C7.43048 20.7085 8.8732 19.5779 8.8732 19.5779L7.84045 18.5947V18.596Z"
                  fill="black"
                />
                <path
                  d="M5.39831 24.0023C5.39831 24.0023 5.00532 23.7569 4.41518 24.0846C3.82503 24.4123 4.53007 24.9372 4.53007 24.9372C4.53007 24.9372 5.85789 25.7075 6.26655 25.6252C6.67522 25.543 6.61124 24.8875 6.23391 24.4123C5.85659 23.9371 5.39831 24.0023 5.39831 24.0023Z"
                  fill="black"
                />
                <path
                  d="M6.17273 25.1546L4.61381 24.4666C4.61381 24.4666 4.67256 24.5149 4.51067 24.6102C4.7496 25.3531 4.4715 26.4329 4.4715 26.4329C4.44016 25.8636 4.25215 25.4027 4.008 25.0371C3.77168 24.793 3.44919 24.1702 2.4543 23.9247C1.52078 23.695 0.527199 24.225 0.156401 25.0998C-0.824124 27.4121 3.06273 28.6798 4.67126 28.7046C5.63612 28.719 6.15314 28.3221 6.25498 27.3651C6.36988 26.284 6.17273 25.1533 6.17273 25.1533V25.1546Z"
                  fill="black"
                />
                <path
                  d="M23.7012 20.6048L24.9454 24.3023L26.2432 23.814L25.3267 18.8252L23.7012 20.6048Z"
                  fill="black"
                />
                <path
                  d="M24.8441 23.9584C24.8441 23.9584 24.1613 24.4676 24.0921 25.0225C24.0229 25.5774 24.4094 25.9743 24.7488 25.8516C25.0883 25.7288 26.6942 24.7078 26.9175 24.4219C27.1407 24.136 26.8457 23.4962 25.8443 23.4544C24.8428 23.4127 24.8428 23.9584 24.8428 23.9584H24.8441Z"
                  fill="black"
                />
                <path
                  d="M24.8306 25.6465C24.8306 25.6465 24.529 28.1102 25.3229 28.6299C26.1167 29.1495 27.9876 27.7851 29.493 27.537C30.9984 27.289 31.7296 26.2053 31.6617 25.2143C31.5938 24.2234 30.8613 23.4805 29.497 23.6476C28.1326 23.8147 27.451 25.3645 27.3309 26.5578C27.3309 26.5578 27.0385 26.1061 27.532 24.8657C27.532 24.8657 27.1011 25.0825 26.6794 24.5171C26.2577 23.9505 24.8306 25.6465 24.8306 25.6465Z"
                  fill="black"
                />
              </svg>
    `,
  },
  {
    name: 'Preset',
    slug: 'Preset',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor"  version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
  <g>
  	<g>
  		<path d="M510.42,144.923c-0.004-0.009,0-0.017-0.006-0.027L428.829,16.243c-1.871-2.95-5.12-4.737-8.613-4.737H91.785    c-3.493,0-6.743,1.788-8.613,4.737L1.586,144.895c-0.01,0.015-0.009,0.03-0.016,0.045C0.58,146.512,0,148.365,0,150.358v339.937    c0,5.632,4.566,10.199,10.199,10.199h491.602c5.633,0,10.199-4.567,10.199-10.199V150.358    C512,148.358,511.416,146.497,510.42,144.923z M97.393,31.904h317.214l68.65,108.254H28.744L97.393,31.904z M144.342,480.096    H115.58v-48.112h28.762V480.096z M347.259,480.096H164.741v-48.112h182.519V480.096z M202.873,411.586v-20.394h106.253v20.394    H202.873z M396.42,480.096h-28.762v-48.112h28.762V480.096z M416.292,411.585h-86.768v-30.594c0-5.632-4.566-10.199-10.199-10.199    H192.674c-5.633,0-10.199,4.567-10.199,10.199v30.594H95.707V340.2c0-9.947,8.094-18.041,18.042-18.041H398.25    c9.948,0,18.041,8.094,18.041,18.041V411.585z M228.02,230.373c0,5.632,4.566,10.199,10.199,10.199h31.379    c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199h-5.49v-7.841h81.57l40.882,89.428H125.442l40.881-89.428h77.385    v7.841h-5.49v0C232.586,220.174,228.02,224.741,228.02,230.373z M491.602,480.096h-74.784v-48.112h9.674    c5.633,0,10.199-4.567,10.199-10.199v-81.584c0-17.174-11.322-31.751-26.893-36.665l-48.293-105.641    c-1.659-3.631-5.284-5.959-9.276-5.959H159.772c-3.992,0-7.617,2.328-9.276,5.959l-48.293,105.641    c-15.571,4.915-26.893,19.492-26.893,36.665v81.584c0,5.632,4.566,10.199,10.199,10.199h9.674v48.112H20.398V160.557h471.203    V480.096z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M307.251,332.092h-9.413c-5.633,0-10.199,4.567-10.199,10.199s4.567,10.199,10.199,10.199h9.413    c5.633,0,10.199-4.567,10.199-10.199S312.884,332.092,307.251,332.092z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M391.975,332.092h-49.16c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h49.16    c5.633,0,10.199-4.567,10.199-10.199S397.608,332.092,391.975,332.092z"/>
  	</g>
  </g>
  </svg>
      `,
  },
  //   {
  //     name: 'Garage',
  //     slug: 'Garage',
  //     icon: `
  //     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor"  version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
  // <g>
  // 	<g>
  // 		<path d="M510.42,144.923c-0.004-0.009,0-0.017-0.006-0.027L428.829,16.243c-1.871-2.95-5.12-4.737-8.613-4.737H91.785    c-3.493,0-6.743,1.788-8.613,4.737L1.586,144.895c-0.01,0.015-0.009,0.03-0.016,0.045C0.58,146.512,0,148.365,0,150.358v339.937    c0,5.632,4.566,10.199,10.199,10.199h491.602c5.633,0,10.199-4.567,10.199-10.199V150.358    C512,148.358,511.416,146.497,510.42,144.923z M97.393,31.904h317.214l68.65,108.254H28.744L97.393,31.904z M144.342,480.096    H115.58v-48.112h28.762V480.096z M347.259,480.096H164.741v-48.112h182.519V480.096z M202.873,411.586v-20.394h106.253v20.394    H202.873z M396.42,480.096h-28.762v-48.112h28.762V480.096z M416.292,411.585h-86.768v-30.594c0-5.632-4.566-10.199-10.199-10.199    H192.674c-5.633,0-10.199,4.567-10.199,10.199v30.594H95.707V340.2c0-9.947,8.094-18.041,18.042-18.041H398.25    c9.948,0,18.041,8.094,18.041,18.041V411.585z M228.02,230.373c0,5.632,4.566,10.199,10.199,10.199h31.379    c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199h-5.49v-7.841h81.57l40.882,89.428H125.442l40.881-89.428h77.385    v7.841h-5.49v0C232.586,220.174,228.02,224.741,228.02,230.373z M491.602,480.096h-74.784v-48.112h9.674    c5.633,0,10.199-4.567,10.199-10.199v-81.584c0-17.174-11.322-31.751-26.893-36.665l-48.293-105.641    c-1.659-3.631-5.284-5.959-9.276-5.959H159.772c-3.992,0-7.617,2.328-9.276,5.959l-48.293,105.641    c-15.571,4.915-26.893,19.492-26.893,36.665v81.584c0,5.632,4.566,10.199,10.199,10.199h9.674v48.112H20.398V160.557h471.203    V480.096z"/>
  // 	</g>
  // </g>
  // <g>
  // 	<g>
  // 		<path d="M307.251,332.092h-9.413c-5.633,0-10.199,4.567-10.199,10.199s4.567,10.199,10.199,10.199h9.413    c5.633,0,10.199-4.567,10.199-10.199S312.884,332.092,307.251,332.092z"/>
  // 	</g>
  // </g>
  // <g>
  // 	<g>
  // 		<path d="M391.975,332.092h-49.16c-5.633,0-10.199,4.567-10.199,10.199s4.566,10.199,10.199,10.199h49.16    c5.633,0,10.199-4.567,10.199-10.199S397.608,332.092,391.975,332.092z"/>
  // 	</g>
  // </g>
  // </svg>
  //     `,
  //   },
];
